import { Component, Input } from '@angular/core';
import { CommonDocumentEditorDetails } from '@primatoo-ms-organization';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'pt-editor-summary',
  templateUrl: './editor-summary.component.html',
  styleUrls: [`editor-summary.component.scss`]
})
export class EditorSummaryComponent {
  @Input() documentEditorDetails: CommonDocumentEditorDetails;
}
